export const URL_HOME = "/";
export const URL_USER = "/user";
export const URL_LOGIN = "/login";
export const URL_SHOP = "/shop";
export const URL_NEWS = "/news";
export const URL_NEWS_DETAILS = "/news-details/";
export const URL_FORUM = "/forum";
export const URL_DOWNLOAD = "/download";
export const PAGE_NOT_FOUND = "/page-not-found"

